/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

import selectionCorner from '../../assets/images/selection_corner.svg';

export const useThumbnailSelectorStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  list: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '-3px',
  },
  listItem: {
    padding: '3px',
  },
  addButton: {
    border: '5px',
    width: '48px',
    height: '48px',
    position: 'relative',
    margin: '5px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: `${theme.palette.primary.main}10`,
    color: theme.palette.primary.main,
    borderRadius: '6px',
    cursor: 'pointer',
    '& input[type=file]': {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      opacity: 0,
      width: '100%',
      height: '100%',
    },
  },
}));

export const useThumbnailSelectorItemStyles = makeStyles(theme => ({
  root: {
    padding: '3px',
    border: '2px solid transparent',
    borderRadius: '6px',
    '&$active': {
      borderColor: theme.palette.primary.main,
    },
    cursor: 'pointer',
  },
  content: {
    width: '48px',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: `${theme.palette.primary.main}10`,
    borderRadius: '6px',
    position: 'relative',
    overflow: 'hidden',
    '$root$active & $activeCorner': {
      display: 'block',
    },
    '& img': {
      maxWidth: '100%',
      maxHeight: '100%',
    },
  },
  active: {},
  activeCorner: {
    display: 'none',
    position: 'absolute',
    right: 0,
    top: 0,
    width: '43px',
    height: '43px',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundImage: `url('${selectionCorner}')`,
  },
}));
